<template>
    <b-modal size="xl" :id="id" scrollable v-model="showModal" @hide="close">
        <template v-slot:modal-title>
            <div class="mb-3 d-block d-md-flex justify-content-between">
                <div class="mb-2 mb-md-0">{{ title }}</div>
                <div class="font-changer">
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button type="button" class="btn btn-sm btm-font-changer" @click="changeFontSize('down')"><span
                                class="icon-minus"></span>
                        </button>
                        <span class="btn btn-sm btn-group-text" @click="changeFontSize('reset')">A</span>
                        <button type="button" class="btn btn-sm btm-font-changer" @click="changeFontSize('up')"><span
                                class="icon-plus"></span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="search-box ">

                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <button class="btn input-group-btn" type="button" @click="onPreviousClick">
                            <span class="icon-chevron-left"></span>
                        </button>
                    </div>
                    <input v-model="searchText" type="text" class="form-control">
                    <div class="input-group-append">
                        <button class="btn input-group-btn" type="button" @click="onNextClick">
                            <span class="icon-chevron-right"></span>
                        </button>
                    </div>
                </div>
            </div>
        </template>


        <div class="modal-content-box" style="height: 550px !important;">
            <HtmlDiv v-if="iframeUrl" id="modal_content_box" v-html="iframeUrlData" :modal="true"></HtmlDiv>
            <div v-else-if="fullText" :style="{ 'font-size': modalFontSize }">{{ fullText }}</div>
            <div v-else :style="{ 'font-size': modalFontSize }">Dokument ne može biti prikazan</div>
            <!--            <iframe id="modal_content_box" :src="iframeUrlData"></iframe>-->
        </div>
        <template v-slot:modal-footer>

            <div class="w-100">
                <b-button variant="primary" size="sm" class="float-right" @click="showModal = false">
                    Затвори прозор
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<!--    <span class="pronadjen"></span>-->
<script>
import axios from "axios"
window.$ = window.jQuery = require('jquery');
import 'jquery-highlight/jquery.highlight.js'
import HtmlDiv from "./HtmlDiv.vue";
import { mapState, mapActions } from "vuex";

export default {
    name: "NewsSingleModal",
    data() {
        return {
            searchText: "",
            fontSize: 100,
            showModal: false,
            iframeUrlData: null,
            scrollIndex: 0,
        };
    },
    props: [
        'id',
        'title',
        'iframeUrl',
        'fullText',
        'close'
    ],
    watch: {
        searchText(newValue) {
            window.$('#modal_content_box').unhighlight({ className: 'pronadjen' });
            if (newValue !== null && newValue.length > 0) {
                window.$('#modal_content_box').highlight(newValue, { className: 'pronadjen' });
            }
            this.scrollIndex = 0;
        },
        iframeUrl(val) {
            if (val) {
                axios.get(this.iframeUrl).then(response => {
                    this.iframeUrlData = response.data;
                    this.$nextTick(() => {
                        this.changeLinks()
                    })
                }).catch(error => {
                    console.log(error);
                });
            }
            else {
                this.iframeUrlData = null;
            }
        }
    },
    computed: {
        ...mapState(['modalFontSize']),
    },
    mounted() {
        axios.get(this.iframeUrl).then(response => {
            this.iframeUrlData = response.data;
            this.$nextTick(() => {
                this.changeLinks()
            })
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        ...mapActions(["setModalFontSize"]),
        changeFontSize(action) {
            switch (action) {
                case 'down':
                    if (this.fontSize >= 85) {
                        this.fontSize = this.fontSize - 5;
                    }
                    break;
                case 'up':
                    if (this.fontSize <= 115) {
                        this.fontSize = this.fontSize + 5;
                    }
                    break;
                default:
                    this.fontSize = 100;
            }
            this.setModalFontSize(this.fontSize + '%');
            //window.$('#modal_content_box')[0].style.fontSize = this.fontSize + '% !important';
        },
        onNextClick() {
            var items = window.$('#modal_content_box').find('.pronadjen');
            if (items && items.length > 0) {
                this.scrollIndex++;
                if (this.scrollIndex > items.length) {
                    this.scrollIndex = 0;
                }
                items[this.scrollIndex].scrollIntoView();
            }
        },
        onPreviousClick() {
            var items = window.$('#modal_content_box').find('.pronadjen');
            if (items && items.length > 0) {
                this.scrollIndex--;
                if (this.scrollIndex < 0) {
                    this.scrollIndex = items.length;
                }
                if (items.length > 0) {
                    items[this.scrollIndex].scrollIntoView();
                }
            }
        },
        changeLinks() {
            window.$("body").on("click auxclick", "#modal_content_box", function (e) {
                if (e.target.nodeName === "A" || e.target.parentElement.nodeName === "A") {
                    if (e.target.nodeName === "A") {
                        if (e.target.href.includes("/viewdoc"))
                            e.target.href = e.target.href.substr(
                                e.target.href.indexOf("/viewdoc")
                            );
                        if (e.target.href.includes("/eli"))
                            e.target.href = e.target.href.substr(
                                e.target.href.indexOf("/eli")
                            );
                    }
                }
            });
        }
    },
    components: { HtmlDiv }
}
</script>

<style>
iframe,
object {
    border: none;
    height: 550px;
    width: 100%;
}

.pronadjen {
    background-color: #ff0 !important;
}
</style>
